import { isPlatformServer, PlatformLocation } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
// import { REQUEST } from '@nguniversal/express-engine/tokens';
import { DataConfig } from './configs';
import { SharedService } from './shared.service';
import { StateService } from './state.service';

// import {RESPONSE} from "./src/express.tokens";

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  private lang = '';
  language = '';

  // _dataConfig = inject(DataConfig);

  constructor(
    private _stateService: StateService,
    private _sharedService: SharedService,
    private _platformLocation: PlatformLocation,
    @Inject('environment') private environment: any,
    @Inject(PLATFORM_ID) private platformId: object,
    @Optional() @Inject('ServerRequestHeader') private creq: any
  ) {}

  isPlatform() {
    if (isPlatformServer(this.platformId)) {
      this._stateService.set('USER_AGENT', this.creq['user-agent']?.match('Mobile')?.length > 0);
      return this.creq['user-agent']?.match('Mobile')?.length > 0;
      // return true;
    } else {
      if (this._stateService.get('USER_AGENT')) {
        return this._stateService.get('USER_AGENT');
      } else {
        return (window.navigator.userAgent?.match('Mobile')?.length as any) > 0;
      }
    }
  }

  async setDefaultLang() {
    const hostname = this._platformLocation.hostname;
    const url = hostname;
    //
    // const url = 'devhotelwl.tport.ir';
    // const url = '192.168.25.80';
    // const url = 'wlpilot.tport.ir';


    const data = await this._sharedService.getWhiteLabel(url);
    this.lang = data.defaultLanguageCode || 'fa';
    DataConfig.set('globalSetting', data);
    return this.lang;
  }

  getSiteLanguageUrl() {
    switch (this._platformLocation.pathname.split('/')[1]) {
      case 'en':
        this.language = 'en';
        return this.language;
      case 'ar':
        this.language = 'ar';
        return this.language;
      case 'fa':
        this.language = 'fa';
        return this.language;
      default:
        this.language = 'fa';
        return this.language;
    }
  }

  getUrl() {
    return this._platformLocation.pathname.split('/');
  }

  siteLanguage() {
    switch (this._platformLocation.pathname.split('/')[1]) {
      case 'en':
        this.language = 'en';
        return this.language;
      case 'ar':
        this.language = 'ar';
        return this.language;
      case 'fa':
        this.language = 'fa';
        return this.language;
      default:
        this.language = '';
        return this.language ;
    }

    //  return this.lang;
  }
}
